import { BorrowerEmploymentStatus } from 'enums/ApplicationsVariables';
import { ActiveMilitaryPaygrade, BranchOfService, GovernmentPaygrade } from 'enums/EmploymentTypes';
import { IncomeType } from 'enums/IncomeType';
import {
  CurrentEmploymentVariable,
  PreviousEmploymentVariable,
} from 'pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.enums';
import { getOptions } from 'utils/inputSelect';

export const EMPLOYMENT_SECTION_VARIABLES = [
  'borrower_current_employer',
  'borrower_position',
  'borrower_employer_phone',
  'borrower_hire_date',
  'borrower_employer_street_address',
];
export const PREVIOUS_EMPLOYMENT_VARIABLES = [
  'borrower_previous_employer_1',
  'borrower_previous_employer_1_position',
  'borrower_previous_employer_1_phone',
  'borrower_previous_employer_1_hire_date',
  'borrower_previous_employer_1_street_address',
];
export const CONTRACTOR_VARIABLES = [
  'funded_contractor_name',
  'funded_contractor_salesperson_name',
  'funded_contractor_salesperson_phone',
  'funded_contractor_salesperson_email',
];
export const EMPLOYMENT_SECTION_AMOUNT = 6;
export const MAX_LOAN_AMOUNT_REQUIREMENT = 75000;
export const MIN_CREDIT_SCORE_REQUIREMENT = 740;
export const MILITARY_PAYGRADE_OPTIONS = getOptions(ActiveMilitaryPaygrade);
export const BRANCH_OF_SERVICE_OPTIONS = getOptions(BranchOfService);
export const GOVERNMENT_PAYGRADE_OPTIONS = getOptions(GovernmentPaygrade);
export const DEFAULT_EMPLOYMENT_VARIABLES = [
  CurrentEmploymentVariable.EmployerName,
  CurrentEmploymentVariable.Position,
  CurrentEmploymentVariable.EmployerPhone,
  CurrentEmploymentVariable.HireDate,
  PreviousEmploymentVariable.EmployerName,
  PreviousEmploymentVariable.Position,
  PreviousEmploymentVariable.EmployerPhone,
  PreviousEmploymentVariable.HireDate,
  PreviousEmploymentVariable.EmploymentStatus,
];
export const ACTIVE_EMPLOYMENT_STATUSES = [
  BorrowerEmploymentStatus.ActiveMilitaryW2,
  BorrowerEmploymentStatus.GovernmentW2,
  BorrowerEmploymentStatus.RetiredMilitary,
  BorrowerEmploymentStatus.RetiredNonMilitary,
];

export const EMPLOYMENT_STATUS_OPTIONS = getOptions(BorrowerEmploymentStatus);

export const EMPLOYMENT_ADDRESS_VARIABLES = [
  CurrentEmploymentVariable.Address,
  CurrentEmploymentVariable.City,
  CurrentEmploymentVariable.State,
  CurrentEmploymentVariable.Zip,
];

export const W2_EMPLOYMENT_VARIABLE_LABELS: Partial<Record<CurrentEmploymentVariable, string>> = {
  [CurrentEmploymentVariable.EmployerName]: 'Employer Name',
  [CurrentEmploymentVariable.Position]: 'Position',
  [CurrentEmploymentVariable.EmployerPhone]: 'Employer Phone',
  [CurrentEmploymentVariable.HireDate]: 'Hire Date',
  [CurrentEmploymentVariable.Address]: 'Employer Street Address',
  [CurrentEmploymentVariable.City]: 'Employer City',
  [CurrentEmploymentVariable.State]: 'Employer State',
  [CurrentEmploymentVariable.Zip]: 'Employer Zip Code',
};

export const MAP_INCOME_TYPE_TO_EMPLOYMENT_VARIABLE_LABELS: Partial<
  Record<IncomeType, Partial<Record<CurrentEmploymentVariable, string>>>
> = {
  [IncomeType.W2]: W2_EMPLOYMENT_VARIABLE_LABELS,
};

export const MAP_INCOME_TYPE_TO_EMPLOYMENT_SECTION_TITLE: Partial<Record<IncomeType, string>> = {
  [IncomeType.W2]: 'Current Employment Information',
};
